import React, { useState } from "react";
import { Nav, NavItem, NavLink } from "react-bootstrap";
import classnames from "classnames";
import ViewCustomMap from "./../../closedLoop/mapAdUpload/customMapViewerEnhanced";
import UploadCustomMap from "./../../closedLoop/mapAdUpload/mapAdUploadEnhanced";

function CustomMapMain() {
    const [activeTabs, setActiveTab] = useState("1");

    function toggle(tab) {
        setActiveTab(tab);
    }

    return (
        <div>
            <div
                className="nav nav-tabs"
                style={{
                    marginLeft: "1%",
                    marginRight: "1%",
                    backgroundColor: "#CACED5",
                }}
            >
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTabs === "1" })}
                            onClick={() => {
                                toggle("1");
                            }}
                            style={
                                activeTabs === "1"
                                    ? { backgroundColor: "#B0ff44" }
                                    : { cursor: "pointer", color: "#464646" }
                            }
                        >
                            View Custom Maps
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTabs === "2" })}
                            onClick={() => {
                                toggle("2");
                            }}
                            style={
                                activeTabs === "2"
                                    ? { backgroundColor: "#B0ff44" }
                                    : { cursor: "pointer", color: "#464646" }
                            }
                        >
                            Upload Custom Maps
                        </NavLink>
                    </NavItem>
                </Nav>
            </div>
            <div>
                {activeTabs === "1" ? <ViewCustomMap /> : null}
                {activeTabs === "2" ? <UploadCustomMap /> : null}
            </div>
        </div>
    );
}

export default CustomMapMain;
